var MARRIAGE_DOM = {
    heightArr: [],
    scrollLocked: false,
    initMarriagePageHeightList() {
        var hArr = [0]; 
        var offsetArr = [60, 62, 68, 60, 68, 60, 60, 68, 60, 60];
        for(let i = 1; i <= 10; i++) {
            let boxDom = document.getElementById('mrgBox'+i);
            let scrollY = hArr[i-1] && boxDom ? hArr[i-1]+boxDom.clientHeight : boxDom ? boxDom.clientHeight : 0;
                scrollY = scrollY+offsetArr[i-1];
            hArr.push(scrollY);
        }
        this.heightArr = hArr;
        // console.log('initMarriagePageHeightList------', hArr);
    },
    updateMarriageScrollTopByTab(tabId) {
        var scrollY = 0;
            scrollY = this.heightArr[tabId-1];
        this.scrollLocked = true;
        setTimeout(() => {
            window.scrollTo({
                left: 0,
                top: scrollY,
                behavior: "smooth",
            });
        }, 20);
        setTimeout(() => {
            this.scrollLocked = false;
        }, 1000);
    },
    bindMarriageScrollEvent() {
        console.log('bindYearScrollEvent');
        var scrollList = this.heightArr, lastI = scrollList.length-1;
        window.onscroll = function() {
            var scrollY = document.documentElement.scrollTop || document.body.scrollTop;
            for(var i = 0; i < scrollList.length; i++) {
                if(!MARRIAGE_DOM.scrollLocked && scrollY == 0) {
                    AppFate.$bus.emit('updateMarriageReportTab', 1);
                }else if(!MARRIAGE_DOM.scrollLocked && scrollY > scrollList[i] - 10 && scrollY <= scrollList[i+1]) {
                    AppFate.$bus.emit('updateMarriageReportTab', i+1);
                }else if(!MARRIAGE_DOM.scrollLocked && i == lastI && scrollY > scrollList[i]) {
                    AppFate.$bus.emit('updateMarriageReportTab', i+1);
                }
            }
        }
    }
}
export {
    MARRIAGE_DOM
}